module.exports = __webpack_public_path__ + "img/F115.d2645592.jpg";